import Vue from 'vue'
import {
  URL_USERS,
  URL_USERS_RESET_CONFIRM_EMAIL
} from '@/constants/urls.js'
import { USER_TYPES } from '@/constants/business.js'
import { USER_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [USER_MANAGEMENT.STATE.USERS]: {
    [USER_TYPES.REGISTERED]: null,
    [USER_TYPES.UNREGISTERED]: null
  },
  [USER_MANAGEMENT.STATE.CURRENT_USER]: null,
  [USER_MANAGEMENT.STATE.PROXIES]: null,
  [USER_MANAGEMENT.STATE.SUBSCRIPTIONS]: null,
  [USER_MANAGEMENT.STATE.ORGANIZERS]: null,
  [USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES]: null
}

const actions = {
  async [USER_MANAGEMENT.ACTIONS.GET_USERS_LIST] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USERS_LIST, {
      users: resp.data,
      status: params.isRegistered
        ? USER_TYPES.REGISTERED
        : USER_TYPES.UNREGISTERED
    })
  },
  async [USER_MANAGEMENT.ACTIONS.GET_ALL_ORGANIZERS] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/organizers?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    // commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_ALL_ORGANIZERS, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.GET_USER_PROXIES_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/proxies?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_PROXIES_ADMIN, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.GET_USER_FOR_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_FOR_ADMIN, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.GET_EXPIRATION_DATES] ({ commit, dispatch }, userId) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${userId}/expirationDates?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_EXPIRATION_DATES, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.CHANGE_USER_LOCK_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/lockStatus`,
      model: { isLocked: model.isLocked }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.GET_USER_SUBSCRIPTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/subscriptions?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_SUBSCRIPTION, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.CHANGE_USER_SUBSCRIPTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/subscriptions`,
      model: model.subscriptions
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_SUBSCRIPTION, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.UPDATE_USER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}`,
      model: model.profile
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(USER_MANAGEMENT.MUTATIONS.GET_USER_FOR_ADMIN, resp.data)
  },
  async [USER_MANAGEMENT.ACTIONS.UPDATE_USER_EMAIL] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/email`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.UPDATE_EXPIRATION_DATE] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/statementExpirationDate`,
      model: { expirationDate: model.expirationDate }
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.CREATE_PROXY_ADMIN] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS}/${model.userId}/proxies`,
      model: model.authorizationDocument
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.RESET_CONFIRM_EMAIL] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USERS_RESET_CONFIRM_EMAIL}/${model.userId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USER_FOR_ADMIN] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USER_FOR_ADMIN)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_ALL_ORGANIZERS] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_ALL_ORGANIZERS)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USER_SUBSCRIPTION] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USER_SUBSCRIPTION)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USERS_LIST] ({ commit }, status) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USERS_LIST, status)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_USER_PROXIES_ADMIN] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_USER_PROXIES_ADMIN)
  },
  async [USER_MANAGEMENT.ACTIONS.CLEAR_EXPIRATION_DATES] ({ commit }) {
    commit(USER_MANAGEMENT.MUTATIONS.CLEAR_EXPIRATION_DATES)
  }
}

const mutations = {
  [USER_MANAGEMENT.MUTATIONS.GET_USERS_LIST] (state, model) {
    state[USER_MANAGEMENT.STATE.USERS][model.status] = model.users
  },
  [USER_MANAGEMENT.MUTATIONS.GET_ALL_ORGANIZERS] (state, users) {
    state[USER_MANAGEMENT.STATE.ORGANIZERS] = users
  },
  [USER_MANAGEMENT.MUTATIONS.GET_USER_PROXIES_ADMIN] (state, proxies) {
    state[USER_MANAGEMENT.STATE.PROXIES] = proxies
  },
  [USER_MANAGEMENT.MUTATIONS.GET_USER_FOR_ADMIN] (state, user) {
    state[USER_MANAGEMENT.STATE.CURRENT_USER] = user
  },
  [USER_MANAGEMENT.MUTATIONS.GET_EXPIRATION_DATES] (state, model) {
    state[USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES] = model
  },
  [USER_MANAGEMENT.MUTATIONS.GET_USER_SUBSCRIPTION] (state, subscriptions) {
    state[USER_MANAGEMENT.STATE.SUBSCRIPTIONS] = subscriptions
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USER_SUBSCRIPTION] (state) {
    state[USER_MANAGEMENT.STATE.SUBSCRIPTIONS] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USER_FOR_ADMIN] (state) {
    state[USER_MANAGEMENT.STATE.CURRENT_USER] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_EXPIRATION_DATES] (state) {
    state[USER_MANAGEMENT.STATE.USER_EXPIRATION_DATES] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_ALL_ORGANIZERS] (state) {
    state[USER_MANAGEMENT.STATE.ORGANIZERS] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USERS_LIST] (state, status) {
    state[USER_MANAGEMENT.STATE.USERS][status] = null
  },
  [USER_MANAGEMENT.MUTATIONS.CLEAR_USER_PROXIES_ADMIN] (state) {
    state[USER_MANAGEMENT.STATE.PROXIES] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
